import { render, staticRenderFns } from "./AccordeonItem.vue?vue&type=template&id=77d91c3f&scoped=true"
import script from "./AccordeonItem.vue?vue&type=script&lang=js"
export * from "./AccordeonItem.vue?vue&type=script&lang=js"
import style0 from "./AccordeonItem.vue?vue&type=style&index=0&id=77d91c3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d91c3f",
  null
  
)

export default component.exports